<button
  class="cta-button"
  [ngClass]="[type, size, isIconOnly ? 'icon-only' : '']"
  [class.highlighted]="highlighted"
  [class.disabled]="disabled || loading"
  [class.full-width]="fullWidth"
  [attr.aria-label]="ariaLabel ?? text"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-busy]="loading || null"
  [disabled]="disabled || loading"
  (click)="onClick()"
>
  @if (loading) {
    <span class="button-spinner"></span>
  } @else if (icon) {
    <ptl-icon [icon]="icon" [size]="size"></ptl-icon>
  }

  <span class="button-text" *ngIf="text">{{ text }}</span>

  <ng-content></ng-content>

  @if (iconSuffix) {
    <ptl-icon [icon]="iconSuffix" [size]="size"></ptl-icon>
  }
</button>
